import { t } from '@/utility/localization';

export const TYPES_OF_PAYMENT_METHODS = {
  paid: 'paid',
  free: 'free',
  NFT: 'nft-gated'
};

export const TYPE_OF_PAYMENT_MODALS = {
  confirm: 'confirm',
  cancel: 'cancel'
};

export const TYPE_OF_RETURN_OBJECT = {
  text: 'text',
  paymentSummary: 'paymentSummary'
};

export const getPaymentConfirmationOrCancelModalsTexts = () => ({
  confirm: {
    title: t('confirm-new-price'),
    getTitle: (changedPaymentType, originalPaymentType) => {
      if (
        changedPaymentType === 'free' &&
        originalPaymentType === 'paid'
      ) {
        return t('change-access-from-paid-to-free');
      }
      if (
        changedPaymentType === 'paid' &&
        originalPaymentType === 'free'
      ) {
        return t('change-access-from-free-to-paid');
      }
      return t('confirm-price-change');
    },
    description: t(
      'you-wont-be-able-to-change-it-once-you-have-your-first-member-has-joined'
    ),
    getDescription: (changedPaymentType, originalPaymentType) => {
      if (
        changedPaymentType === 'free' &&
        originalPaymentType === 'paid'
      ) {
        return {
          type: TYPE_OF_RETURN_OBJECT.text,
          text: t(
            'price-changes-will-only-be-applied-for-new-members-existing-members-will-continue-to-pay-the-price-charged-upon-signup'
          )
        };
      }
      if (
        changedPaymentType === 'paid' &&
        originalPaymentType === 'free'
      ) {
        return {
          type: TYPE_OF_RETURN_OBJECT.text,
          text: t(
            'price-changes-will-only-be-applied-for-new-members-existing-members-will-continue-to-pay-the-price-charged-upon-signup'
          )
        };
      }
      if (
        changedPaymentType === 'paid' &&
        originalPaymentType === 'paid'
      ) {
        // Build up object to display pricing changes on confirmation modal
        return {
          type: TYPE_OF_RETURN_OBJECT.text,
          text: t(
            'price-changes-will-only-be-applied-for-new-members-existing-members-will-continue-to-pay-the-price-charged-upon-signup'
          )
        };
      }
      return t(
        'you-wont-be-able-to-change-it-once-you-have-your-first-member-has-joined'
      );
    },
    cancelButton: t('cancel'),
    confirmButton: t('confirm')
  },
  cancel: {
    title: t('discard-changes2'),
    description: t(
      'are-you-sure-you-want-to-discard-the-changes-you-have-made-to-the-member-access'
    ),
    cancelButton: t('cancel'),
    discardButton: t('discard-changes1')
  }
});

export const ROLE_CONFIGURATION_LINK =
  'https://support.discord.com/hc/en-us/articles/206029707-Setting-Up-Permissions-FAQ#h_01FFTVYQ38W9TVCTM6YZHZXFFA';

export const countryCurrencyMap = {
  PHP: 'Philippines'
};

export const learnMoreUrl =
  'https://help.nas.io/en/articles/7911827-what-currencies-are-supported-on-nas-io-for-membership';
